import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=372c7a55&scoped=true"
import script from "./budget.vue?vue&type=script&lang=js"
export * from "./budget.vue?vue&type=script&lang=js"
import style0 from "./budget.vue?vue&type=style&index=0&id=372c7a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c7a55",
  null
  
)

export default component.exports